<template>
    <div>
        <template v-if="loading">
            <div class="car-search__dummy-listing dummy-listing">
                <div class="dummy-listing__background dummy-listing__background--animated">
                    <div class="dummy-listing__wrap">
                        <div class="dummy-listing__left">

                        </div>
                        <div class="dummy-listing__right">
                            <div class="dummy-listing__space dummy-listing__space--title dummy-listing__space--left dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--title dummy-listing__space--right dummy-listing__masker"></div>
                            <div class="clear"></div>
                            <div class="dummy-listing__space dummy-listing__space--divider  dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--left dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--right dummy-listing__masker"></div>
                            <div class="clear"></div>
                            <div class="dummy-listing__space dummy-listing__space--divider dummy-listing__space--divider-xs dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--left dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--right dummy-listing__masker"></div>
                            <div class="clear"></div>
                            <div class="dummy-listing__space dummy-listing__space--divider dummy-listing__space--divider-xs dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--left dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--right dummy-listing__space--double dummy-listing__masker"></div>
                            <div class="clear"></div>
                            <div class="dummy-listing__space dummy-listing__space--divider dummy-listing__space--divider-xs dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--left dummy-listing__masker"></div>
                            <div class="dummy-listing__space dummy-listing__space--right dummy-listing__space--double dummy-listing__masker"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="!loading && initialLoad">
            <slot></slot>
        </template>

        <article class="listing mpanel" v-if="!loading && !initialLoad && hasCurrentListing">
            <figure class="listing__figure listing-figure">
                <a :href="currentListing.vehicle.url" rel="nofollow" :target="currentListing.vehicle.urlTarget" class="listing__image--a">
                    <img class="listing-figure__image" :src="currentListing.vehicle.imageUrl" :alt="(offerType === 'used' && currentListing.vehicle.registrationYear ? currentListing.vehicle.registrationYear + ' ' : '' ) + currentListing.vehicle.make + ' ' + currentListing.vehicle.model">
                    <div class="listing-figure__image-counter" v-if="currentListing.vehicle.imageCount > 0 && currentListing.paymentMethod === 'ppe'">
                        <i class="fi-picture"></i>
                        {{ currentListing.vehicle.imageCount }}
                        <template v-if="currentListing.vehicle.imageCount > 1">
                            photos
                        </template>
                        <template v-else>
                            photo
                        </template>
                    </div>
                    <div v-if="offerType === 'used'" class="listing-figure__star" @click.prevent="toggleStarred">
                        <i class="fi-star listing-figure__star-icon" :class="{'listing-figure__star-icon--active': currentListingIsStarred}"></i>
                    </div>
                </a>
            </figure>
            <div class="listing__content">
                <header class="listing__header">
                    <div class="listing__titles">
                        <h2 class="listing__title">{{ currentListing.vehicle.make }} {{ currentListing.vehicle.model }}</h2>
                        <div class="listing__sub-title">
                            {{ currentListing.vehicle.derivative }}
                        </div>
                    </div>

                    <div class="listing__price">
                        <template v-if="currentListing.vehicle.offerType === 'used' && priceType === 'finance'">
                            From <span class="listing__price--large"> &pound;{{ formatAmount(currentListing.vehicle.monthlyPrice, 2) }}</span> p/m

                            <finance-info v-if="currentListing.vehicle.pcpInfo || currentListing.vehicle.hpInfo" :pcp-info="currentListing.vehicle.pcpInfo" :hp-info="currentListing.vehicle.hpInfo"></finance-info>
                        </template>
                        <template v-else-if="currentListing.vehicle.offerType === 'used' && currentListing.vehicle.monthlyPrice">
                            <span class="listing__price--large">&pound;{{ formatAmount(currentListing.vehicle.price, 0) }}</span>
                            <br>
                            <finance-info v-if="currentListing.vehicle.pcpInfo || currentListing.vehicle.hpInfo" :pcp-info="currentListing.vehicle.pcpInfo" :hp-info="currentListing.vehicle.hpInfo">
                                or <span>&pound;{{ formatAmount(currentListing.vehicle.monthlyPrice, 2) }}</span> p/m</finance-info>
                        </template>
                        <template v-else>
                            <span class="listing__price--large">&pound;{{ formatAmount(currentListing.vehicle.price, 0) }}</span>
                        </template>
                        <template v-if="!currentListing.vehicle.vatIncluded">
                            <br>
                            <span class="text-grey-darkest text-xs">excluding VAT</span>
                        </template>
                    </div>
                </header>

                <ul class="listing__specs">
                    <li v-if="currentListing.vehicle.offerType === 'used' && currentListing.vehicle.registrationYear">
                        {{ currentListing.vehicle.registrationYear }}
                    </li>
                    <li  v-if="currentListing.vehicle.offerType === 'used' && currentListing.vehicle.mileage > 1">
                        {{ formatAmount(currentListing.vehicle.mileage, 0) }} miles
                    </li>
                    <li v-if="currentListing.vehicle.bodyStyle">
                        {{ capitalizeFirstLetter(currentListing.vehicle.bodyStyle) }}
                    </li>
                    <li v-if="currentListing.vehicle.fuel">
                        {{ currentListing.vehicle.fuel }}
                    </li>
                    <li v-if="currentListing.vehicle.transmission">
                        {{ currentListing.vehicle.transmission }}
                    </li>
                    <li v-if="currentListing.vehicle.offerType === 'new' && currentListing.vehicle.mpg > 2">
                        {{ currentListing.vehicle.mpg }} MPG
                    </li>
                    <li v-if="currentListing.vehicle.roadTaxAmount">
                        &pound;{{ currentListing.vehicle.roadTaxAmount }} Road tax
                    </li>
                    <li v-if="currentListing.vehicle.ulezExempt">
                        ULEZ exempt
                    </li>
                    <li v-if="currentListing.vehicle.wheelbase">
                        {{ currentListing.vehicle.wheelbase }}
                    </li>
                </ul>
                <div class="row">
                    <div class="col-8 col-12-xs" style="align-self: center;">


                        <div class="listing__dealer" v-if="offerType === 'used'">
                            <span class="listing__dealer-name">
                                <a :href="dealerUrl" target="_blank">
                                    {{ currentListing.dealer.company }}
                                </a>
                                <div class="d-inline-block" v-if="currentListing.dealer.rating > 0">
                                    <i v-for="n in 5" :class="{'fi-star': true, 'star__basic': true, 'star__basic--full' : Math.round(currentListing.dealer.rating) > n - 1}"></i>
                                </div>
                            </span>

                            <div>
                                <template v-if="currentListing.distance">
                                    <template v-if="currentListing.distance > 1">
                                        <i class="fi-location text-navy"></i>{{ formatAmount(currentListing.distance, 1) }} miles away -
                                    </template>
                                    <template v-if="currentListing.distance <= 1">
                                        <i class="fi-location text-navy"></i>within 1 mile -
                                    </template>
                                </template>
                                <a :href="dealerStockUrl" rel="nofollow">See all stock</a>
                            </div>

                            <div>
                                <i class="fi-phone text-navy"></i>
                                <a :href="'tel:' + currentListing.dealer.telephone"> {{ currentListing.dealer.telephone }} </a>
                            </div>
                        </div>

                        <div v-if="offerType === 'used' && (currentListing.dealer.thirtyOneDayCount || currentListing.vehicle.thirtyOneDayCount)">
                            <i class="fi-cog text-orange"></i>
                            {{ currentListing.vehicle.thirtyOneDayCount ?? 0 }}
                            <i class="fi-user text-orange"></i>
                            {{ currentListing.dealer.thirtyOneDayCount ?? 0 }}
                        </div>

                        <div class="listing__distance"  v-if="offerType === 'new'">
                            <i class="fi-location text-navy"></i>
                            National Delivery
                        </div>
                    </div>
                    <div class="col-4 col-12-xs" style="align-self: flex-end;">
                        <div class="pb-10 d-none d-block-xs"></div>
                        <a :href="currentListing.vehicle.url" rel="nofollow" :target="currentListing.vehicle.urlTarget" class="button button--ghost button--full button--small">
                            Go!
                        </a>
                    </div>
                </div>
            </div>

        </article>
    </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import numberFormatter from '../../modules/numberFormatter';
import CarSearchFinanceInfo from './car-search-finance-info.vue';

export default defineComponent({
    components: {
        'finance-info': CarSearchFinanceInfo,
    },
    props: {
        'initialLoad': Boolean,
        'loading': Boolean,
        'listingIndex': {type: Number, required: true},
        'listings': {type: Array, required: true},
        'partner': String,
        'offerType': String,
        'priceType': String,
        'starredIds': {type: Array as PropType<string[]>, required: true},
    },
    data() {
        return {
        };
    },
    methods: {
        toggleStarred() {
            this.$emit('toggle-starred', this.currentListing.vehicle.externalId);
        },
        formatAmount: numberFormatter.formatAmount,
        capitalizeFirstLetter(string: string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
    },
    computed: {
        hasCurrentListing(): boolean {
            return !!this.listings[this.listingIndex];
        },
        currentListing(): any {
            return this.listings[this.listingIndex];
        },
        dealerStockUrl(): string {
            if (!this.currentListing) {
                return '';
            }

            return `/${this.offerType}-cars/all/pricetype-cash_dealer-${this.currentListing.dealer.slug}`;
        },
        dealerUrl(): string {
            if (!this.currentListing) {
                return '';
            }

            return `/car-dealers/${this.currentListing.dealer.slug}`;
        },
        currentListingIsStarred(): boolean {
            const currentListing = this.listings[this.listingIndex] as any;

            return currentListing &&
                currentListing.vehicle &&
                currentListing.vehicle.externalId &&
                this.starredIds.includes(currentListing.vehicle.externalId);
        },
    },
});
</script>
